import { useEffect } from 'react';

export const CHARACTER_THEMES = [
  {
    id: 'default',
    label: 'Par défaut',
    description: 'Style standard du forum, sobre et lisible.',
  },
  {
    id: 'batman',
    label: 'Batman',
    description: 'Gotham nocturne : angles nets, signal doré, ombres profondes et typographie héroïque.',
  },
  {
    id: 'superman',
    label: 'Superman',
    description: 'Metropolis héroïque : bleu profond, cape rouge et éclats dorés, lumière d\'espoir.',
  },
];

const VALID_THEME_IDS = new Set(CHARACTER_THEMES.map((theme) => theme.id));

const BODY_SITE_THEME_ATTR = 'data-character-site-theme';
const PUBLIC_URL = process.env.PUBLIC_URL || '';

const THEME_FILIGRANES = {
  batman: `url(${PUBLIC_URL}/images/batman-watermark.png)`,
  superman: `url(${PUBLIC_URL}/images/superman-filigrane.png)`,
};

const SITE_THEME_BACKGROUND = {
  backgroundRepeat: 'no-repeat, no-repeat, no-repeat',
  backgroundSize: 'auto, auto, cover',
  backgroundPosition: 'center center, center center, center center',
};

function applySiteThemeBackground() {
  Object.assign(document.body.style, SITE_THEME_BACKGROUND);
}

function clearSiteThemeBackground() {
  document.body.style.removeProperty('background-repeat');
  document.body.style.removeProperty('background-size');
  document.body.style.removeProperty('background-position');
}

export const normalizeSheetTheme = (theme) => (
  VALID_THEME_IDS.has(theme) ? theme : 'default'
);

export const normalizeThreadTheme = normalizeSheetTheme;

export const getCharacterThemeLabel = (themeId) => {
  const theme = CHARACTER_THEMES.find((item) => item.id === themeId);
  return theme?.label || 'Par défaut';
};

export function useCharacterSiteTheme(sheetTheme) {
  useEffect(() => {
    const theme = normalizeSheetTheme(sheetTheme);

    if (theme === 'default') {
      document.body.removeAttribute(BODY_SITE_THEME_ATTR);
      document.body.style.removeProperty('--bg-filigrane');
      clearSiteThemeBackground();
    } else {
      document.body.setAttribute(BODY_SITE_THEME_ATTR, theme);
      const filigrane = THEME_FILIGRANES[theme];
      if (filigrane) {
        document.body.style.setProperty('--bg-filigrane', filigrane);
        applySiteThemeBackground();
      } else {
        document.body.style.removeProperty('--bg-filigrane');
        clearSiteThemeBackground();
      }
    }

    return () => {
      document.body.removeAttribute(BODY_SITE_THEME_ATTR);
      document.body.style.removeProperty('--bg-filigrane');
      clearSiteThemeBackground();
    };
  }, [sheetTheme]);
}
